import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CanvasApp from './CanvasApp.jsx';
import AdminApp from './AdminApp.jsx';
import '@xyflow/react/dist/style.css';
import './styles.css';
import './canvas.css';

const query = new URLSearchParams(window.location.search);
const mode = query.get('app');
// The legacy creation surface is served by the static create.html wrapper.
// Keep the React bundle focused on canvas and its standalone admin surface.
const RootApp = mode === 'admin' ? AdminApp : CanvasApp;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RootApp />
  </StrictMode>
);
